module.exports = __webpack_public_path__ + "static/media/punchy.409762fe.png";